import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { Auth0ProviderWithNavigate } from "./Auth0ProviderWithNavigate";
import { Auth0ErrorBoundary } from "./components/Auth0ErrorBoundary";
import "./styles/styles.css";
import "./styles/lexend-fonts.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Auth0ErrorBoundary>
          <Auth0ProviderWithNavigate>
            <App />
          </Auth0ProviderWithNavigate>
        </Auth0ErrorBoundary>
      </BrowserRouter>
    </React.StrictMode>
);
